var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M14.5 11H7.26a1.505 1.505 0 0 1-1.446-1.1l-.349-1.255a.262.262 0 0 1-.008-.037L3.7 1.38A.498.498 0 0 0 3.212 1H.5a.499.499 0 1 1 0-1h2.713C3.91 0 4.508.47 4.671 1.145L6.338 8h7.919a.5.5 0 0 0 .476-.354l.902-3.001a.499.499 0 0 0-.48-.645H7.502a.499.499 0 1 1 0-1h7.654c.48 0 .918.221 1.204.605.286.385.37.869.233 1.327l-.9 3A1.504 1.504 0 0 1 14.256 9H6.603l.176.633a.5.5 0 0 0 .482.365h7.24a.5.5 0 0 1 0 1M8 13.5a.5.5 0 1 0 .002 1.002A.5.5 0 0 0 8 13.5m0 2c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m5-2c-.274 0-.5.226-.5.5 0 .275.226.5.5.5.275 0 .5-.225.5-.5 0-.274-.225-.5-.5-.5m0 2c-.826 0-1.5-.673-1.5-1.5s.674-1.5 1.5-1.5c.828 0 1.5.673 1.5 1.5s-.672 1.5-1.5 1.5"})));
}

Cart.defaultProps = {"width":"17","height":"16"};

module.exports = Cart;

Cart.default = Cart;
